import ProjectProperties, {ProjectAvailableMenuOptions} from "../project-properties"
import ProjectSession from "../../project-session";

export default class ProjectTagProperties extends ProjectProperties {

    constructor(properties:any, project:ProjectSession) {
        super(properties, project)

        this.canHaveStatus              = true // I think we might need it .. like tag = sprint = need status? not sure esli chestno skoree net tam nuzno chto to drugoe

        this.menuSections.customers     = false
        this.menuSections.integrations  = false
        this.menuSections.settings      = false
    }

    get availableMenuOptions(): ProjectAvailableMenuOptions {

        const canMove = !this.project.isGlobalTag // global tags should never be moved

        return {
            pinStar         : true,
            info            : true,
            users           : true,
            settings        : false,
            status          : false,
            archive         : false,
            history         : true,
            rename          : true,
            editSource      : false,
            colorIcon       : true,
            move            : canMove,
            convert         : false,
            duplicate       : false,
            saveAsTemplate  : false,
            delete          : true,
            directLink      : true,
            showInMenu      : true,
        }
    }
}
